import "./trustbar.css";

const trustItems = [
  { icon: "📐", label: "Professional Designs" },
  { icon: "🏆", label: "10+ Years Experience" },
  { icon: "🚚", label: "Nationwide Delivery" },
  { icon: "💰", label: "Affordable Plans" },
  { icon: "📋", label: "Compliant Standards" },
  { icon: "🤝", label: "100% Client Satisfaction" },
  { icon: "💬", label: "Always Available Support" },
  { icon: "🏗️", label: "End-to-End Construction" },
];

function TrustBar() {
  return (
    <div className="bg-white border-y border-gray-100 py-3 overflow-hidden font-Montserrat">
      <div className="trust-track">
        {/* Duplicated twice for seamless infinite loop */}
        {[...trustItems, ...trustItems].map(({ icon, label }, i) => (
          <div key={i} className="trust-item">
            <span className="text-lg">{icon}</span>
            <span className="text-xs md:text-sm font-semibold text-gray-700 whitespace-nowrap">
              {label}
            </span>
            <span className="trust-dot" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default TrustBar;
